export const blockTypeToBlockName = {
  code: 'Code Block',
  h1: 'Heading 1',
  h2: 'Heading 2',
  h3: 'Heading 3',
  h4: 'Heading 4',
  h5: 'Heading 5',
  h6: 'Heading 6',
  paragraph: 'Normal',
  quote: 'Quote',
  equation: 'Equation'
};
export const listTypeToListName = {
  bullet: 'Bulleted List',
  check: 'Check List',
  number: 'Numbered List',
  default: 'Select List'
};
export const elementFormatName = {
  left: 'Left Align',
  center: 'Center Align',
  right: 'Right Align',
  justify: 'Justify Align',
  indent: 'Indent',
  outdent: 'Outdent'
};
export enum TEXT_STYLE {
  BOLD = 'bold',
  ITALIC = 'italic',
  UNDERLINE = 'underline',
  STRIKETHROUGH = 'strikethrough',
  CODE = 'code',
  SUBSCRIPT = 'subscript',
  SUPERSCRIPT = 'superscript',
}